import { useMutation } from "@tanstack/react-query";
import { addOrder } from "./api/orders";

export const useAddOrder = (token) => {
  return useMutation({
    mutationFn: async (orderData) => addOrder(token, orderData),
    onSuccess: (data) => {
      console.log("Order created successfully:", data);
    },
    onError: (error) => {
      console.error("Failed to create order:", error.response?.data || error);
    },
  });
};
